import OriginalTimeline from './Timeline.svelte';
import Item from './Item.svelte';
const Timeline = OriginalTimeline;
Timeline.Item = Item;
export default Timeline;
